<template>
  <div class="summaryA">
    <div class="A_one fx mb02">
        <div class="A_one_left  wow animate__bounceInLeft">
            <img src="@/assets/computer/summary/LOGO.png" style="width: 100%;">
        </div>
        <div class="A_one_right wow animate__bounceInRight fs_0075 lh02">
            <div class="mb02">南昌世弘泛亚科技股份有限公司，是一家注重创意体验的数字文化展览服务供应商，致力于通过人机交互、裸眼3D、全息影像、VR、AR等数字新媒体技术，展现设计之美感和文化之底蕴，以独特的创意和设计理念，重塑人们对于展馆的新体验。并在业务领域持续为客户提供展馆前期咨询、策划、设计、多媒体制作、软硬件集成、实施及后期运营维护的一站式服务及全方位的数字创意解决方案。</div>
            <div class="mb02">同时公司也是一家融合计算机图形学【VR&AR】/卫星遥感、人工智能和大数据技术，为城市治理智慧化、工业制造智能化、文旅产业数字化、教育培训互娱化、民生服务网格化赋能的中国原创性技术研发高新技术企业。</div>
            <div class="mb02">公司历经十余年的发展，已成立“数字多媒体智慧展厅设计和信息化技术软件开发”两大事业部，积聚了众多行业内设计创意的人才，下设六大创意创新部门，拥有完备的策划设计、内容研发、项目实施、售后运营服务团队。</div>
            <div class="mb02">公司沉淀10余年行业经验，服务客户500+，项目遍布全省11个地市，全国多个城市，覆盖10多个行业领域。</div>

            <div class="A_one_num fx f_j_sb pt02">
                <div>
                    <div class="fs_025 fw_5 fx fa_c color4">
                        <countTo
                        :startVal="startVal1" 
                        :endVal="endVal1" 
                        :duration="1000" 
                        :autoplay="true"
                        id="counts1"
                        ></countTo>
                        <span class="fs_0075 lh0075  color1">项</span>
                    </div>
                    <div class="fs_007">发明专利</div>
                </div>
                <div>
                    <div class="fs_025 fw_5 fx color4 " style="position: relative;">
                        <countTo
                        :startVal="startVal4" 
                        :endVal="endVal4" 
                        :duration="1000" 
                        :autoplay="true"
                        id="counts2"
                        ></countTo>
                        <span class=" fs_0075 lh0075">＋</span>
                    </div>
                    <div class="pb_002 fs_007">服务客户数量超200</div>
                    <div class="fs_007"></div>
                </div>
                <div >
                    <div class="fs_025 fw_5 fx fa_c  color4 ">
                        <countTo
                        :startVal="startVal2" 
                        :endVal="endVal2" 
                        :duration="1000" 
                        :autoplay="true"
                        id="counts2"
                        ></countTo>
                        <span class="fs_0075 color1 lh0075">项</span>
                    </div>
                    <div class="pb_002 fs_007">软件著作权等核心自主知识产权</div>
                    <div class="fs_007"></div>
                </div>
                <div>
                    <div class="fs_025 fw_5 fx color4 " style="position: relative;">
                        <countTo
                        :startVal="startVal3" 
                        :endVal="endVal3" 
                        :duration="1000" 
                        :autoplay="true"
                        id="counts2"
                        ></countTo>
                        <span class=" fs_0075 lh0075">＋</span>
                    </div>
                    <div class="pb_002 fs_007">服务客户数量超200</div>
                    <div class="fs_007"></div>
                </div>
            </div>
        </div>
    </div>
 
    <img src="@/assets/computer/summary/z176.png" class="mt02 mb02 wow animate__fadeInUp" style="width: 100%;">
    <div class="A_two fx mt02">
        <div class="A_two_left wow animate__fadeInLeftBig">
            <div  v-for="(item,index) in imglist" >
                <img :src="item" v-if="indexT ==index" style="width: 100%;display:block;">
            </div>
        </div>
        <div class="A_two_right wow animate__fadeInRightBig">
            <div class="fw_5 fs_02 mb006">项目类型涉及 <span class="ml002">-</span></div>
            <div class="fs_0075 color8 mb02">PROJECT TYPES INVOLVE</div>

            <div :class=" indexT==index ?' fx f_a_c f_j_sb back xm_item mb008':' fx f_a_c f_j_sb xm_item mb008' " @click="xmClick(index)" v-for="(item,index) in xmlist" >
                <img :src="item.img1" style="width:0.08rem;height:0.08rem;" v-if="indexT==index">
                <img :src="item.img" style="width:0.08rem;height:0.08rem;" v-else>
                <div class="fs_01">{{ item.text }}</div>
                <img :src="item.jt" style="width:0.08rem;height:auto;" v-if="indexT==index">
                <img :src="item.jt1" style="width:0.08rem;height:auto;" v-else>
            </div>
        </div>
    </div>

    <div class="A_three">
        <div class="fw_5 fs_02 mb006">业务范围涵盖 <span class="ml002">-</span></div>
        <div class="fs_0075 color8 mb02">BUSINESS SCOPE COVERS</div>
        <div class="A_three_list fx f_j_sb">
            <div class="A_three_item wow animate__flipInY mt02 mb02 fx f_a_c tc " v-for="(item,index) in textlist">
                <div class="A_three_radiu fx fx_flow_j f_j_ce">
                    <div class="fs_01 pb_006 color9">{{ item.num }}</div>
                    <div class="fw_8 fs_0092">{{ item.text1 }}</div>
                    <div class="fw_8 fs_0092">{{ item.text2 }}</div>
                </div>
                <div class="fw_8 fs_007 jiah" v-if="textlist.length-1!==index" >+</div>
            </div>
        </div>
       
    </div>
  </div>
</template>

<script setup>

 import TSwiper1 from '@/components/computer/Tswiper1.vue'
 import { useRouter } from 'vue-router'
 import {ref, nextTick, onMounted, reactive,defineProps } from "vue";
 import { Swiper } from 'swiper/vue';
 const router = useRouter()
 import { CountTo } from 'vue3-count-to'
const startVal1 = ref(0)
const endVal1 = ref(1)
const startVal2 = ref(0)
const endVal2 = ref(1)
const startVal3 = ref(0)
const endVal3 = ref(1)
const startVal4 = ref(0)
const endVal4 = ref(1)


onMounted(() => {
    endVal1.value = 6
    endVal4.value = 10
    endVal2.value = 32
    endVal3.value = 500
});
const indexT = ref(0)
const imglist = ref([
    require('@/assets/computer/summary/djzt.png'),
    require('@/assets/computer/summary/qyzt.png'),
    require('@/assets/computer/summary/whzt.png'),
    require('@/assets/computer/summary/zszt.png'),
    require('@/assets/computer/summary/gyzt.png'),
    require('@/assets/computer/summary/cszt.png'),
])

const xmlist =ref([
    {
        text:'党建展厅',
        img:require('@/assets/computer/summary/gsjj1.png'),
        img1:require('@/assets/computer/summary/gsjj2.png'),
        jt:require('@/assets/computer/shouye/xRight2.png'),
        jt1:require('@/assets/computer/shouye/xRight3.png'),
        jh:'+'
    },{
        text:'企业展厅',
        img:require('@/assets/computer/summary/wh1.png'),
        img1:require('@/assets/computer/summary/wh2.png'),
        jt:require('@/assets/computer/shouye/xRight2.png'),
        jt1:require('@/assets/computer/shouye/xRight3.png'),
        jh:'+'
    },{
        text:'文化展厅',
        img:require('@/assets/computer/summary/hx1.png'),
        img1:require('@/assets/computer/summary/hx2.png'),
        jt:require('@/assets/computer/shouye/xRight2.png'),
        jt1:require('@/assets/computer/shouye/xRight3.png'),
        jh:''
    },{
        text:'招商展厅',
        img:require('@/assets/computer/summary/fzlc1.png'),
        img1:require('@/assets/computer/summary/fzlc2.png'),
        jt:require('@/assets/computer/shouye/xRight2.png'),
        jt1:require('@/assets/computer/shouye/xRight3.png'),
        jh:'+'
    },{
        text:'工业展厅',
        img:require('@/assets/computer/summary/qyry1.png'),
        img1:require('@/assets/computer/summary/qyry2.png'),
        jt:require('@/assets/computer/shouye/xRight2.png'),
        jt1:require('@/assets/computer/shouye/xRight3.png'),
        jh:'+'
    },{
        text:'城市展厅',
        img:require('@/assets/computer/summary/gsjj1.png'),
        img1:require('@/assets/computer/summary/gsjj2.png'),
        img:require('@/assets/computer/summary/gsjj1.png'),
        jt:require('@/assets/computer/shouye/xRight2.png'),
        jt1:require('@/assets/computer/shouye/xRight3.png'),
    }
])
const textlist = ref([
    {  num:'01' ,text1:'展馆设计',text2:'实施' },
    {  num:'02' ,text1:'数字',text2:'多媒体' },
    {  num:'03' ,text1:'数据',text2:'可视化' },
    {  num:'04' ,text1:'布展',text2:'实施' },
    {  num:'05' ,text1:'运营',text2:'维护' },
    {  num:'06' ,text1:'改造',text2:'拓展' },
])
const xmClick = (e)=>{
    indexT.value = e
}

</script>

<style scoped>
.back{
    background-color: red;
    color: #fff;
}
.A_one{
    width: 80%;
    margin:  0 auto 0.3rem;
}
.A_one_left{
    width: 30%;
    margin-right: 10%;
}
.A_one_right{
    width: 60%;
}
.A_one_num{
    width: 100%;
}
.A_two{
    width: 85%;
    margin:  0.4rem auto 0;
}
.A_two_left{
    width: 73%;
    margin-right: 9%;
}
.A_two_right{
    width: 18%;
}
.xm_item{
    width: 85%;
    padding: 0.1rem 10%;
}
.A_three{
    width: 85%;
    margin: 0.5rem auto ;
}
.A_three_list{
    width: 100%;
}
.A_three_radiu{
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 100%;
    border: 1px solid #d3d3d3;
}
.A_three_item{
    position: relative;
}
.jiah{
    position: absolute;
    right: -0.28rem;
}
</style>
